import { useMediaQuery, useTheme } from '@mui/material'
import { Styles } from 'react-joyride'

/** Main tour guide styles */
export const useTourGuideStyles = (): Partial<Styles> => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return {
    tooltipContainer: {
      textAlign: 'start',
    },
    tooltip: {
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(2),
      width: isMobile ? 320 : 400,
    },
    buttonPrimary: {
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(2),
    },
    buttonBack: {
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(2),
    },
    buttonSkip: {
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(2),
    },
  }
}
